import { ClassicPreset } from 'rete';
import { WorkflowActionTypes } from 'src/app/models/RestApiCaller/Enums/workflow-action-types';
import { AnyActionData } from '../../models/Types/any-action-data';
import { NodeEvent } from './node-event';

/**
 * Représente un noeud correspondant à une action de workflow.
 */
export class WorkflowActionNode extends ClassicPreset.Node {
    public width = 235;
    public height = 85;

    /**
     * Constructeur.
     * @param name : Nom de l'action de workflow.
     * @param type : Type d'action de workflow.
     * @param workflowActionData : Données de l'action de workflow.
     * @param callBack : Callback appellé pour gérer les évènements du noeud.
     */
    constructor(
        name: string,
        public type: WorkflowActionTypes,
        public workflowActionData: AnyActionData,
        public callBack: (id: string, data: NodeEvent) => void
    ) {
        super(name);
    }
}
